export default {
  methods: {
    closeModal() {
      this.$store.dispatch('modal/close')
    },
  },
}
